import React from 'react';
import classNames from 'classnames';
import styles from './index.less';

const PageNotFound = ({
  title,
  description,
  className,
}) => {
  const titleClasses = classNames('header-404', styles.title);
  const descClasses = classNames('description-404', styles.desc);

  return (
    <div className={classNames(styles.pageNotFound, className)}>
      {
        title && <h1 className={titleClasses}>{title}</h1>
      }
      {
        description && <p className={descClasses}>{description}</p>
      }
    </div>
  );
};

PageNotFound.defaultProps = {
  className: '',
  title: 'Oops!',
  description: 'This page is not available!',
};

export default PageNotFound;
